/* Training world: progressive reveal.
   Elements start hidden only once this file runs, so a script failure leaves
   the page fully readable rather than blank. */
(function () {
  var root = document.documentElement;
  if (root.classList.contains("js-iw-tr")) return;

  var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function show(el) { el.classList.add("is-in"); }

  function start() {
    var targets = document.querySelectorAll(".iw-tr__reveal, .iw-tr .segment-bar");
    if (!targets.length) return;

    if (reduce || !("IntersectionObserver" in window)) {
      Array.prototype.forEach.call(targets, show);
      return;
    }

    root.classList.add("js-iw-tr");

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: "0px 0px -6% 0px" });

    Array.prototype.forEach.call(targets, function (el) { io.observe(el); });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
